import React, {useContext, useState} from 'react';
import {Image, Platform, ScrollView, Pressable, ImageBackground} from 'react-native';
import * as Yup from 'yup';
import Button from '../components/Button';
import Input from '../components/Input';
import MainStyle from '../../MainStyle';
import {StoreContext} from '../components/StoreContextProvider';
import kiosk_logo_RGB_1row from '../assets/img/evenplay-logo-long.svg';
import {useFormik} from 'formik';
import {LANDING_PAGE_URL} from "../constants";
import HelpLinkModalTrigger from '../modals/HelpLinksModal';
import ServiceClient from "../utils/ServiceClient";
import EmailNotExistModal from "../modals/EmailNotExistModal";
import OtpModal from "../modals/OtpModal";
import bg from '../assets/img/loading page.png';
import {useNavigation} from "@react-navigation/native";
import {colors} from "../assets/styles/colors";
import Div from "../lib/Div";
import P from "../lib/P";
import {getFieldError} from "../utils";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";

type Props = { onSuccessLogin?: () => void };

const LoginWithPin = (props: Props) => {
  const [showEmailNotExistDialog, setShowEmailNotExistDialog] = useState(false);
  const Context = useContext(StoreContext);
  const {cancelModalConfig} = Context;
  const [phoneVerificationDialog, setPhoneVerificationDialog] = useState(false);
  const formik = useFormik({
    initialValues: {email: ''}, validationSchema: Yup.object({email: Yup.string().email().required()}),
    onSubmit: (values) => {
      checkUserEmailExists(values.email);
    }
  });
  const navigation: NativeStackNavigationProp<any> = useNavigation();

  const errorModalClose = () => {
    Context.setCancelModalConfig({...cancelModalConfig, visible: false});
  };

  const checkUserEmailExists = (email: string) => {
    Context.setLoadingOverlay(true);

    ServiceClient.checkUserEmailExists(email).then(isExists => {
      if (isExists) {
        requestOtpCode(email);

      } else {
        Context.setLoadingOverlay(false);
        setShowEmailNotExistDialog(true);
      }

    }).catch(err => {
      console.log('checkUserEmailExists err', err);
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'Error', subtitle: err.message, rightBtnText: 'OK',
        onResume: errorModalClose
      });
    });
  };

  const requestOtpCode = (email: string) => {
    ServiceClient.requestOtpCode({email}).then(() => {
      Context.setLoadingOverlay(false);
      setPhoneVerificationDialog(true);

    }).catch(err => {
      console.log('requestOtpCode err', err);
      Context.setLoadingOverlay(false);

      Context.setCancelModalConfig({
        visible: true, title: 'Error', subtitle: err.message, rightBtnText: 'OK',
        onResume: errorModalClose
      });
    });
  };

  const goBack = () => {
    // navigation.reset({index: 0, routes: [{name: 'Splash'}]});
    if (Platform.OS === 'web') window.open(LANDING_PAGE_URL, '_self');
  };

  return (
    <Div bg={colors.loading_login} flex={1}>
      <ImageBackground source={bg} style={MainStyle.flex1} imageStyle={{opacity: 0.8}}>
        <HelpLinkModalTrigger position="absolute" top={5} right={5}/>

        <ScrollView contentContainerStyle={[MainStyle.full_h, MainStyle.full_w]}>
          <Pressable style={[MainStyle.m_t_7, MainStyle.m_x_auto, MainStyle.m_b_125]} onPress={goBack}>
            <Image source={kiosk_logo_RGB_1row as any} style={[MainStyle.h_46, MainStyle.w_176]}/>
          </Pressable>

          <Div flex={1} alignItems="center">
            <P fw="500" fs={30} lh={24} mb={59}>Create Account or Sign In</P>

            <Input
              w={390} placeholder="Enter Email" label="EMAIL ADDRESS" type="email-address"
              value={formik.values.email} onChangeText={formik.handleChange('email')}
              onBlur={formik.handleBlur('email')} error={getFieldError('email', formik)}
            />
          </Div>

          <P fw="500" ta="center" mb={46}>
            <P color={colors.newGreenText} onPress={() => navigation.navigate('TermsAndConditions')}>Terms and
              Conditions</P> and <P color={colors.newGreenText} onPress={() => navigation.navigate('PrivacyPolicy')}>Privacy
            Policy</P>
          </P>

          <Button text="Let's Go!" onPress={() => formik.handleSubmit()} w={389} mb={86} mx="auto"/>
        </ScrollView>

        <EmailNotExistModal
          visible={showEmailNotExistDialog} onClose={() => setShowEmailNotExistDialog(false)}
          email={formik.values.email}
        />

        <OtpModal
          visible={phoneVerificationDialog} setVisible={() => setPhoneVerificationDialog(false)} isLoginPage
          email={formik.values.email}
          onSuccess={() => {
            if (props.onSuccessLogin) props.onSuccessLogin();
            else navigation.reset({index: 0, routes: [{name: 'challenges'}]});
          }}
        />
      </ImageBackground>
    </Div>
  );
};

export default LoginWithPin;
